
export type NotificationItemBasicInfoType = typeof NotificationItemBasicInfoType[keyof typeof NotificationItemBasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationItemBasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
